import React from 'react';
import { Check } from 'lucide-react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
const completedItems = ['Business type', 'Tax details', 'Business details', 'Account representative', 'Products or services', 'Public details', 'Statement descriptor'];
const remainingItems = ['Add extras', 'Review and submit'];
export function ChecklistMockup() {
  return <MockWindow data-id="element-44" data-mp="3hwsz95id1n1x">
      <div className="px-[3cqw] py-[2cqw]" data-id="element-45" data-mp="3hxb3aob9l5ke">
        <div className="flex items-center gap-[0.8cqw]" data-id="element-46" data-mp="3cyriwscbk1u5">
          <span className="flex h-[1.6cqw] w-[1.6cqw] items-center justify-center rounded-full bg-[#635BFF]" data-id="element-47" data-mp="3cz9hhvmges58">
            <Check className="h-[1.1cqw] w-[1.1cqw] text-white" strokeWidth={3} data-id="element-48" data-mp="385yanuhn6bdb" />
          </span>
          <span className="text-[1.25cqw] font-semibold text-mm-black" data-id="element-49" data-mp="338ofdy7kn5hk">Verify your business</span>
        </div>
        <ul className="ml-[0.75cqw] mt-[0.5cqw] flex flex-col gap-[0.45cqw] border-l-[0.15cqw] border-[#635BFF] pl-[1.4cqw]" data-id="element-50" data-mp="4kr7hocyd2iz">
          {completedItems.map(item => <li key={item} className="flex items-center gap-[0.6cqw]" data-id="element-51" data-mp="2e9osc388zvod">
              <span className="flex h-[1.1cqw] w-[1.1cqw] items-center justify-center rounded-full bg-[#635BFF]" data-id="element-52" data-mp="2ib08li58f4jw">
                <Check className="h-[0.8cqw] w-[0.8cqw] text-white" strokeWidth={3} data-id="element-53" data-mp="24ikbsz2xc2rf" />
              </span>
              <span className="text-[1.05cqw] text-mm-muted-charcoal" data-id="element-54" data-mp="29h5b8wacqiet">{item}</span>
            </li>)}
        </ul>

        <Highlight tone="go" tag="Click here" className="mt-[1.4cqw] inline-block" data-id="element-55" data-mp="1unabqgw365ga">
          <div className="flex items-center gap-[0.8cqw] pr-[0.4cqw]" data-id="element-56" data-mp="1zlk64p9zl20u">
            <span className="h-[1.6cqw] w-[1.6cqw] rounded-full border-[0.15cqw] border-dashed border-mm-mid-gray" data-id="element-57" data-mp="1llj6te9de2nh" />
            <span className="text-[1.25cqw] font-semibold text-mm-black" data-id="element-58" data-mp="1qk46nckpmkbe">Secure your account</span>
          </div>
        </Highlight>

        <ul className="mt-[1.2cqw] flex flex-col gap-[1cqw]" data-id="element-59" data-mp="3fwo7c9p5tyyl">
          {remainingItems.map(item => <li key={item} className="flex items-center gap-[0.8cqw]" data-id="element-60" data-mp="3iiynrnpqnwr1">
              <span className="h-[1.6cqw] w-[1.6cqw] rounded-full border-[0.15cqw] border-dashed border-mm-light-gray" data-id="element-61" data-mp="3ik9qrlbd10h3" />
              <span className="text-[1.25cqw] text-mm-mid-gray" data-id="element-62" data-mp="3ejppq6no1cpo">{item}</span>
            </li>)}
        </ul>
      </div>
    </MockWindow>;
}